import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getMeghivottEloadok, createMeghivottEloadok, updateMeghivottEloadok, getSzak } from "../../apis/SzakokFinder";
import SideTile from "../SideTile";
// import "../../components/Ujszak.css";
// import "./MeghivottEloadok.css";
import "./SzakjelentesCreate.css";
import "./RadioButton.css";
import RichTextEditor from "../RichTextEditor";
import { useFormSave } from "../../context/FormSaveContext";
import { LanguageProvider, useLanguage } from "../../context/LanguageContext";
import TopAlert from '../../components/TopAlert';
import * as MeghivottEloadokOptions from './MeghivottEloadokOptions';
import { MEGHIVOTT_ELOADOK_TRANSLATIONS } from './MeghivottEloadokTranslations';


const MeghivottEloadokContent = ({ szakKod }) => {

    const [isSideTileVisible] = useState(true); // Added state for controlling SideTile visibility
    const { registerSaveHandler, unregisterSaveHandler } = useFormSave();
    const { language, loading } = useLanguage();


    const { szakId } = useParams();
    const navigate = useNavigate();
    const sideTileRef = useRef(null);

    const [meghivottEloadokData, setMeghivottEloadokData] = useState({
        aacsb_akkreditacio: "",
        abet_akkreditacio: "",
        oktatoi_lefedettseg_megjegyzes: "",
        kulfoldi_vendeg_szama: "",
        filling_status: 1
    });

    const [nemzetkoziAkkreditacioValasztas, setNemzetkoziAkkreditacioValasztas] = useState([]);
    const [oktatoiLefedettsegValasztas, setOktatoiLefedettsegValasztas] = useState("");
    const [meghivottEloadokReszvetelValasztas, setMeghivottEloadokReszvetelValasztas] = useState("");
    const [kulsoHelyszinValasztas, setKulsoHelyszinValasztas] = useState("");
    const [uzemlatoValasztas, setUzemlatoValasztas] = useState("");
    const [kulfoldiVendegValasztas, setKulfoldiVendegValasztas] = useState("");

    const [isNew, setIsNew] = useState(true);
    const [szakStatus, setSzakStatus] = useState(1); // Mely státuszban van a szakjelentés

    // Helper function to build JSONB structure for radio buttons
    const buildRadioData = (selectedValue, options) => {
        if (!selectedValue) return null;
        return {
            selected: selectedValue,
            options: options
        };
    };

    // Helper function to build JSONB structure for multi-select checkboxes
    const buildMultiSelectData = (selectedValues, options) => {
        if (!selectedValues || selectedValues.length === 0) return null;
        return {
            selected: selectedValues,
            options: options
        };
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Lekérjük a szak adatait a státusz beállításához
                const szakResponse = await getSzak(szakId);
                if (szakResponse.data && szakResponse.data.data) {
                    setSzakStatus(szakResponse.data.data.status);
                }

                const meghivottEloadokResponse = await getMeghivottEloadok(szakId);
                if (meghivottEloadokResponse.data.data) {
                    const data = meghivottEloadokResponse.data.data;
                    setMeghivottEloadokData(data);
                    
                    // Load checkbox selection from JSONB
                    if (data.nemzetkozi_akkreditacio_valasztas) {
                        setNemzetkoziAkkreditacioValasztas(data.nemzetkozi_akkreditacio_valasztas.selected || []);
                    }
                    
                    // Load section 11.2 radio button
                    if (data.oktatoi_lefedettseg_valasztas) {
                        setOktatoiLefedettsegValasztas(data.oktatoi_lefedettseg_valasztas.selected || "");
                    }
                    
                    // Load section 11.3 radio buttons
                    if (data.meghivott_eloadok_reszvetel_valasztas) {
                        setMeghivottEloadokReszvetelValasztas(data.meghivott_eloadok_reszvetel_valasztas.selected || "");
                    }
                    if (data.kulso_helyszin_valasztas) {
                        setKulsoHelyszinValasztas(data.kulso_helyszin_valasztas.selected || "");
                    }
                    if (data.uzemlato_valasztas) {
                        setUzemlatoValasztas(data.uzemlato_valasztas.selected || "");
                    }
                    if (data.kulfoldi_vendeg_valasztas) {
                        setKulfoldiVendegValasztas(data.kulfoldi_vendeg_valasztas.selected || "");
                    }
                    
                    setIsNew(false);
                } else {
                    const newRecord = { 
                        aacsb_akkreditacio: "", 
                        abet_akkreditacio: "", 
                        nemzetkozi_akkreditacio_valasztas: null,
                        oktatoi_lefedettseg_valasztas: null,
                        oktatoi_lefedettseg_megjegyzes: "", 
                        meghivott_eloadok_reszvetel_valasztas: null,
                        kulso_helyszin_valasztas: null,
                        uzemlato_valasztas: null,
                        kulfoldi_vendeg_valasztas: null,
                        kulfoldi_vendeg_szama: null, 
                        filling_status: 1 
                    };
                    await createMeghivottEloadok(szakId, newRecord);
                    window.location.reload();  // Oldal újratöltése az új rekord létrehozása után
                }
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    const newRecord = { 
                        aacsb_akkreditacio: "", 
                        abet_akkreditacio: "", 
                        nemzetkozi_akkreditacio_valasztas: null,
                        oktatoi_lefedettseg_valasztas: null,
                        oktatoi_lefedettseg_megjegyzes: "", 
                        meghivott_eloadok_reszvetel_valasztas: null,
                        kulso_helyszin_valasztas: null,
                        uzemlato_valasztas: null,
                        kulfoldi_vendeg_valasztas: null,
                        kulfoldi_vendeg_szama: null, 
                        filling_status: 1 
                    };
                    await createMeghivottEloadok(szakId, newRecord);
                    window.location.reload();  // Oldal újratöltése az új rekord létrehozása után
                } else {
                    console.error("Error fetching data:", error);
                }
            }
        };
        fetchData();
    }, [szakId]);

    // Register auto-save handler for token expiry
    useEffect(() => {
        const autoSaveHandler = async () => {
            // Parse kulfoldi_vendeg_szama properly
            let parsedSzama = null;
            if (meghivottEloadokData.kulfoldi_vendeg_szama !== "" && meghivottEloadokData.kulfoldi_vendeg_szama !== null) {
                const num = parseInt(meghivottEloadokData.kulfoldi_vendeg_szama);
                parsedSzama = isNaN(num) ? null : num;
            }
            
            const updatedData = { 
                ...meghivottEloadokData, 
                filling_status: 2,
                kulfoldi_vendeg_szama: parsedSzama
            }; // Always save with status 2
            try {
                if (isNew) {
                    await createMeghivottEloadok(szakId, updatedData);
                } else {
                    await updateMeghivottEloadok(szakId, updatedData);
                }
            } catch (error) {
                console.error("Error auto-saving data:", error);
            }
        };

        registerSaveHandler(autoSaveHandler);

        return () => {
            unregisterSaveHandler();
        };
    }, [meghivottEloadokData, isNew, szakId, registerSaveHandler, unregisterSaveHandler]);

    const handleSubmit = async (e, status) => {
        e.preventDefault();
        
        // Parse kulfoldi_vendeg_szama properly
        let parsedSzama = null;
        if (meghivottEloadokData.kulfoldi_vendeg_szama !== "" && meghivottEloadokData.kulfoldi_vendeg_szama !== null) {
            const num = parseInt(meghivottEloadokData.kulfoldi_vendeg_szama);
            parsedSzama = isNaN(num) ? null : num;
        }
        
        const updatedData = { 
            ...meghivottEloadokData, 
            filling_status: status,
            kulfoldi_vendeg_szama: parsedSzama,
            nemzetkozi_akkreditacio_valasztas: buildMultiSelectData(nemzetkoziAkkreditacioValasztas, nemzetkoziAkkreditacioOptions),
            oktatoi_lefedettseg_valasztas: buildRadioData(oktatoiLefedettsegValasztas, oktatoiLefedettsegOptions),
            meghivott_eloadok_reszvetel_valasztas: buildRadioData(meghivottEloadokReszvetelValasztas, meghivottEloadokReszvetelOptions),
            kulso_helyszin_valasztas: buildRadioData(kulsoHelyszinValasztas, kulsoHelyszinOptions),
            uzemlato_valasztas: buildRadioData(uzemlatoValasztas, uzemlatoOptions),
            kulfoldi_vendeg_valasztas: buildRadioData(kulfoldiVendegValasztas, kulfoldiVendegOptions)
        };

        try {
            if (isNew) {
                await createMeghivottEloadok(szakId, updatedData);
            } else {
                await updateMeghivottEloadok(szakId, updatedData);
            }

            window.location.reload();  // Oldal újratöltése mentés vagy véglegesítés után
        } catch (error) {
            console.error("Error submitting data:", error);
            alert("Error submitting data.");
        }
    };

    const handleNext = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/oktatok-ertekelese`);
    };

    const handleBack = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/versenytars-elemzes`);
    };

    const isFormValid = () => {
        const hasContent = (html) => {
            if (!html) return false;
            // Remove HTML tags and check if there's actual text
            const text = html.replace(/<[^>]*>/g, '').trim();
            return text.length > 0;
        };

        // Check if checkbox is selected
        const checkboxSelected = nemzetkoziAkkreditacioValasztas.includes('nem_vesz_reszt');

        // Check if RichTextEditors have content
        const hasAacsb = hasContent(meghivottEloadokData.aacsb_akkreditacio);
        const hasAbet = hasContent(meghivottEloadokData.abet_akkreditacio);

        // Count how many are filled
        const filledCount = [checkboxSelected, hasAacsb, hasAbet].filter(Boolean).length;

        // Validation: Exactly one of the three options must be selected/filled
        const section11_1Valid = filledCount === 1;

        return (
            section11_1Valid &&
            oktatoiLefedettsegValasztas !== "" &&
            meghivottEloadokReszvetelValasztas !== "" &&
            kulsoHelyszinValasztas !== "" &&
            uzemlatoValasztas !== "" &&
            kulfoldiVendegValasztas !== "" &&
            meghivottEloadokData.kulfoldi_vendeg_szama !== ""
        );
    };

    const handleFinalize = (e) => {
        if (isFormValid()) {
            handleSubmit(e, 3);  // Call handleSubmit with status 3 (finalize)
        } else {
            // Show top alert instead of native alert
            setAlertMessage(t.alerts?.requiredFields || "Minden szöveges mezőt ki kell tölteni!");
            setShowAlert(true);
        }
    };

    const handleRevertFinalize = async (e) => {
        e.preventDefault();
        const updatedData = { ...meghivottEloadokData, filling_status: 2 };

        try {
            await updateMeghivottEloadok(szakId, updatedData);
            window.location.reload();  // Reload the page after reverting finalize
        } catch (error) {
            console.error("Error reverting finalize:", error);
            alert("Error reverting finalize.");
        }
    };

    const handleChange = (field, value) => {
        setMeghivottEloadokData(prevState => ({
          ...prevState,
          [field]: value, // Save the updated HTML content
        }));
      };

    // Helper to check if content exists
    const hasContent = (html) => {
        if (!html) return false;
        const text = html.replace(/<[^>]*>/g, '').trim();
        return text.length > 0;
    };

    // Top alert state
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    // Get translations and options for current language
    const t = loading ? {} : (MEGHIVOTT_ELOADOK_TRANSLATIONS[language] || MEGHIVOTT_ELOADOK_TRANSLATIONS.hu);
    const nemzetkoziAkkreditacioOptions = loading ? [] : (MeghivottEloadokOptions.NEMZETKOZI_AKKREDITACIO_OPTIONS[language] || MeghivottEloadokOptions.NEMZETKOZI_AKKREDITACIO_OPTIONS.hu);
    const oktatoiLefedettsegOptions = loading ? [] : (MeghivottEloadokOptions.OKTATOI_LEFEDETTSEG_OPTIONS[language] || MeghivottEloadokOptions.OKTATOI_LEFEDETTSEG_OPTIONS.hu);
    const meghivottEloadokReszvetelOptions = loading ? [] : (MeghivottEloadokOptions.MEGHIVOTT_ELOADOK_RESZVETEL_OPTIONS[language] || MeghivottEloadokOptions.MEGHIVOTT_ELOADOK_RESZVETEL_OPTIONS.hu);
    const kulsoHelyszinOptions = loading ? [] : (MeghivottEloadokOptions.KULSO_HELYSZIN_OPTIONS[language] || MeghivottEloadokOptions.KULSO_HELYSZIN_OPTIONS.hu);
    const uzemlatoOptions = loading ? [] : (MeghivottEloadokOptions.UZEMLATO_OPTIONS[language] || MeghivottEloadokOptions.UZEMLATO_OPTIONS.hu);
    const kulfoldiVendegOptions = loading ? [] : (MeghivottEloadokOptions.KULFOLDI_VENDEG_OPTIONS[language] || MeghivottEloadokOptions.KULFOLDI_VENDEG_OPTIONS.hu);

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div className="szakjelentes-create-wrapper">
        <div className="uj-szak-page">
            {showAlert && (
                <TopAlert message={alertMessage} onClose={() => setShowAlert(false)} duration={5000} />
            )}
            <SideTile ref={sideTileRef} id={szakId} texts={t.sidebar || []}
            isVisible={isSideTileVisible}
            />
            <div className="uj-szak-container">
                <h1 className="esg-title">{t.esgTitle}</h1>
                <form onSubmit={(e) => handleSubmit(e, 2)}>
                    <h1>{t.section1?.title}</h1>
                    <div className="card">
                        <h2>{t.section1?.titleA}</h2>
                        <p>{t.section1?.descriptionA}</p>
                        <div className="form-group">
                            <RichTextEditor
                                name="aacsb_akkreditacio"
                                value={meghivottEloadokData.aacsb_akkreditacio}
                                onChange={(value) =>
                                    handleChange("aacsb_akkreditacio", value)
                                  }
                                disabled={meghivottEloadokData.filling_status === 3 || hasContent(meghivottEloadokData.abet_akkreditacio) || nemzetkoziAkkreditacioValasztas.includes('nem_vesz_reszt')}
                            />
                        </div>

                        <h3>{t.section1?.titleB}</h3>
                        <p>{t.section1?.descriptionB}</p>
                        <div className="form-group">
                            <RichTextEditor
                                name="abet_akkreditacio"
                                value={meghivottEloadokData.abet_akkreditacio}
                                onChange={(value) =>
                                    handleChange("abet_akkreditacio", value)
                                  }
                                disabled={meghivottEloadokData.filling_status === 3 || hasContent(meghivottEloadokData.aacsb_akkreditacio) || nemzetkoziAkkreditacioValasztas.includes('nem_vesz_reszt')}
                            />
                        </div>

                        <div className="form-group">
                            {nemzetkoziAkkreditacioOptions.map((option) => (
                                <div className="checkbox-group" key={option.value}>
                                    <input
                                        type="checkbox"
                                        id={`nemzetkozi_akkreditacio_${option.value}`}
                                        value={option.value}
                                        checked={nemzetkoziAkkreditacioValasztas.includes(option.value)}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setNemzetkoziAkkreditacioValasztas([option.value]);
                                            } else {
                                                setNemzetkoziAkkreditacioValasztas([]);
                                            }
                                        }}
                                        disabled={meghivottEloadokData.filling_status === 3 || hasContent(meghivottEloadokData.aacsb_akkreditacio) || hasContent(meghivottEloadokData.abet_akkreditacio)}
                                    />
                                    <label htmlFor={`nemzetkozi_akkreditacio_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="card">
                        <h2>{t.section2?.title}</h2>
                        <div className="form-group">
                            {oktatoiLefedettsegOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`oktatoi_lefedettseg_${option.value}`}
                                        name="oktatoi_lefedettseg"
                                        value={option.value}
                                        checked={oktatoiLefedettsegValasztas === option.value}
                                        onChange={(e) => setOktatoiLefedettsegValasztas(e.target.value)}
                                        disabled={meghivottEloadokData.filling_status === 3}
                                    />
                                    <label htmlFor={`oktatoi_lefedettseg_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        <h4>{t.section2?.noteLabel}</h4>
                        <div className="form-group">
                            <RichTextEditor
                                name="oktatoi_lefedettseg_megjegyzes"
                                value={meghivottEloadokData.oktatoi_lefedettseg_megjegyzes}
                                onChange={(value) =>
                                    handleChange("oktatoi_lefedettseg_megjegyzes", value)
                                  }
                                disabled={meghivottEloadokData.filling_status === 3}
                            />
                        </div>
                    </div>

                    <div className="card">
                        <h2>{t.section3?.title}</h2>
                        
                        <h4>{t.section3?.question1}</h4>
                        <div className="form-group">
                            {meghivottEloadokReszvetelOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`meghivott_eloadok_reszvetel_${option.value}`}
                                        name="meghivott_eloadok_reszvetel"
                                        value={option.value}
                                        checked={meghivottEloadokReszvetelValasztas === option.value}
                                        onChange={(e) => setMeghivottEloadokReszvetelValasztas(e.target.value)}
                                        disabled={meghivottEloadokData.filling_status === 3}
                                    />
                                    <label htmlFor={`meghivott_eloadok_reszvetel_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        <h4>{t.section3?.question2}</h4>
                        <div className="form-group">
                            {kulsoHelyszinOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`kulso_${option.value}`}
                                        name="kulso_helyszin"
                                        value={option.value}
                                        checked={kulsoHelyszinValasztas === option.value}
                                        onChange={(e) => setKulsoHelyszinValasztas(e.target.value)}
                                        disabled={meghivottEloadokData.filling_status === 3}
                                    />
                                    <label htmlFor={`kulso_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        <h4>{t.section3?.question3}</h4>
                        <div className="form-group">
                            {uzemlatoOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`uzemlato_${option.value}`}
                                        name="uzemlato"
                                        value={option.value}
                                        checked={uzemlatoValasztas === option.value}
                                        onChange={(e) => setUzemlatoValasztas(e.target.value)}
                                        disabled={meghivottEloadokData.filling_status === 3}
                                    />
                                    <label htmlFor={`uzemlato_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        <h4>{t.section3?.question4}</h4>
                        <div className="form-group">
                            {kulfoldiVendegOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`kulfoldi_${option.value}`}
                                        name="kulfoldi_vendeg"
                                        value={option.value}
                                        checked={kulfoldiVendegValasztas === option.value}
                                        onChange={(e) => setKulfoldiVendegValasztas(e.target.value)}
                                        disabled={meghivottEloadokData.filling_status === 3}
                                    />
                                    <label htmlFor={`kulfoldi_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        <h4>{t.section3?.question5}</h4>
                        <div className="form-group">
                            <input
                                type="number"
                                name="kulfoldi_vendeg_szama"
                                value={meghivottEloadokData.kulfoldi_vendeg_szama || ""}
                                onChange={(e) => handleChange("kulfoldi_vendeg_szama", e.target.value)}
                                placeholder={t.section3?.numberPlaceholder}
                                disabled={meghivottEloadokData.filling_status === 3}
                                style={{ width: '100px', padding: '8px', fontSize: '14px' }}
                            />
                        </div>
                    </div>

                    <div className="button-container-left">
                        <button className="szak-button" onClick={handleBack}>{t.buttons?.previous}</button>
                        <div className="spacer"></div>
                        <button className="szak-button" onClick={handleNext}>{t.buttons?.next}</button>
                    </div>
                    <div className="szak-button-container">
                        <button className="szak-button" type="submit" disabled={meghivottEloadokData.filling_status === 3 || szakStatus >= 2}>{t.buttons?.save}</button>
                        {meghivottEloadokData.filling_status === 3 ? (
                            <button className="szak-button finalize-button" type="button" onClick={handleRevertFinalize} disabled={szakStatus >= 2}>{t.buttons?.unfinalize}</button>
                        ) : (
                            <button className="szak-button finalize-button" type="button" onClick={handleFinalize} disabled={szakStatus >= 2}>{t.buttons?.finalize}</button>
                        )}
                    </div>
                </form>
            </div>
        </div>
        </div>
    );
};

const MeghivottEloadok = () => {
    const { szakId } = useParams();
    const [szakKod, setSzakKod] = useState(null);

    useEffect(() => {
        const fetchSzakKod = async () => {
            try {
                const response = await getSzak(szakId);
                setSzakKod(response.data.data.szak_kod);
            } catch (error) {
                console.error("Error fetching szak_kod:", error);
            }
        };

        fetchSzakKod();
    }, [szakId]);

    if (!szakKod) {
        return <div>Loading page...</div>;
    }

    return (
        <LanguageProvider szakKod={szakKod}>
            <MeghivottEloadokContent szakKod={szakKod} />
        </LanguageProvider>
    );
};

export default MeghivottEloadok;
